import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Header } from 'shared/components/Header';
import { clickOpenModal } from 'shared/components/tracking';
import { selectUser } from 'shared/selectors/user';

interface IHeaderContainerProps {
  onChangeModalVisible: VoidFunction;
}

export const HeaderContainer: React.FC<IHeaderContainerProps> = ({ onChangeModalVisible }) => {
  const device = useDeviceType();

  const user = useSelector(selectUser);

  const userId = user?.isAuthenticated && user.userId ? user.userId : undefined;

  const menuRef = createRef<HTMLDivElement>();

  const { state: isOpenMenu, toggle: toggleIsOpenMenu } = useToggleState(false);

  useEffect(() => {
    return clearAllBodyScrollLocks();
  }, []);

  useEffect(() => {
    if (menuRef.current) {
      const bodyScrollAction = isOpenMenu ? disableBodyScroll : enableBodyScroll;
      bodyScrollAction(menuRef.current);
    }
  }, [isOpenMenu, menuRef]);

  const handleOpenModal = () => {
    onChangeModalVisible();
    clickOpenModal('rentFlat', userId);
  };

  return (
    <Header
      onChangeModalVisible={handleOpenModal}
      isOpen={isOpenMenu}
      device={device}
      onOpenMenu={toggleIsOpenMenu}
      menuRef={menuRef}
    />
  );
};
